import type { RouteRecordRaw } from 'vue-router'

const anonymousRoutes: RouteRecordRaw[] = [
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('../themes/anonymous/signin.vue'),
    meta: { 
      requiresAuth: false,
      layout: 'anonymous'
    }
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import('../themes/anonymous/signup.vue'),
    meta: { 
      requiresAuth: false,
      layout: 'anonymous'
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../themes/anonymous/forgotpassword.vue'),
    meta: { 
      requiresAuth: false,
      layout: 'anonymous'
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../themes/anonymous/resetpassword.vue'),
    meta: { 
      requiresAuth: false,
      layout: 'anonymous'
    }
  },
  {
    path: '/setup-cluster',
    name: 'SetupCluster',
    component: () => import('../themes/anonymous/resetpassword.vue'),
    meta: { 
      requiresAuth: false,
      layout: 'anonymous'
    }
  },
  {
    path: '/oauth-callback',
    name: 'OAuthCallback',
    component: () => import('../themes/anonymous/oauth-callback.vue'),
    meta: {
      requiresAuth: false,
      layout: 'anonymous'
    }
  }
]

export { anonymousRoutes }
